import { ComponentProps, FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { RefundPolicy } from '../../components/refundPolicy/RefundPolicy';
import {
    getFeatureFlags,
    getIsAppRebrandActive,
    getRefundPolicySettings,
    isEventbriteTLD,
} from '../../selectors/app';
import { getIsFreeEvent } from '../../selectors/event';
import { getIsPaymentView } from '../../selectors/routing';
import { CheckoutState } from '../../state';

const mapStateToProps = (
    state: CheckoutState,
): ComponentProps<typeof RefundPolicy> => {
    const featureFlags = getFeatureFlags(state) ?? {};

    // enableRefundFeeRetentionPolicy sometimes is 0 or 1 instead of true or false
    const enableRefundFeeRetentionPolicy =
        !!featureFlags.enableRefundFeeRetentionPolicy;

    const isFreeEvent = getIsFreeEvent(state);
    const hideRefundPolicy = isEventbriteTLD(state) || isFreeEvent;
    const showRefundPolicy = !hideRefundPolicy;

    return {
        enableRefundFeeRetentionPolicy,
        showRefundPolicy,
        isAppRebrandActive: getIsAppRebrandActive(state),
        isPaymentsPage: getIsPaymentView(state),
        ...getRefundPolicySettings(state),
    };
};

export type ConnectedProps = ReturnType<typeof mapStateToProps>;

export const connectRefundPolicy = <OriginalProps extends ConnectedProps>(
    ComponentClass: FunctionComponent<OriginalProps>,
): FunctionComponent<Omit<OriginalProps, keyof ConnectedProps>> =>
    connect(mapStateToProps)(ComponentClass);
